import React, { useEffect, useState } from "react";
import CameraFrame from "../../inspection/cameraFrame";
import CaptureInstructionBanner from "src/components/UI/CaptureInstructionBanner";
import { captureTimingLogger } from "src/services/captureTimingLogger";
import StepTransitionSheet from "./StepTransitionSheet";
import { CameraStreamProps } from "../types/cameraStreamProps";
import "src/components/UI/cameraOverlay.scss";
import "./detectObjectStep.scss";

interface DetectObjectStepProps {
  humanText: string;
  target: string[];
  activeQuestionIds: string[];
  onComplete: () => void;
  cameraStreamProps: CameraStreamProps;
  /**
   * "label" or "container", for the banner title pill. Pass explicitly when
   * `target` mixes both (e.g. a skipped label step folds label classes into
   * the container step). Otherwise it's guessed from `target`.
   */
  captureType?: "label" | "container";
}

const DetectObjectStep: React.FC<DetectObjectStepProps> = ({
  humanText,
  target,
  activeQuestionIds,
  onComplete,
  cameraStreamProps,
  captureType,
}) => {
  const [stepComplete, setStepComplete] = useState(false);
  const stepKey = `${humanText}-${target.join(",")}-${activeQuestionIds.join(",")}`;
  useEffect(() => {
    setStepComplete(false);
  }, [stepKey]);
  // "container" / "label" only — the badge has no "unknown" visual, so an
  // unresolved target falls back to the container badge/copy rather than
  // rendering nothing.
  const resolvedCaptureType =
    captureType ??
    (captureTimingLogger.resolveObjectType(target) === "label" ? "label" : "container");
  return (
    <div className="detect-object-step pwa-fullscreen-viewport">
      <div className="detect-object-step__banner-overlay">
        <CaptureInstructionBanner type={resolvedCaptureType} instruction={humanText} />
      </div>
      <CameraFrame
        onCapture={() => setStepComplete(true)}
        targetClasses={target}
        activeQuestionIds={activeQuestionIds}
        cameraStreamProps={cameraStreamProps}
      />
      { stepComplete && <StepTransitionSheet
        headerMessage="Photo Uploaded!"
        message="AI analysis running in background. Moving to next step."
        onClose={onComplete}
      />}
    </div>
  );
};
export default DetectObjectStep;
